import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NetworkSpeedService {
  private _isSlow = signal(false);

  constructor() {
    const connection = (navigator as any).connection;
    if (connection) {
      this._isSlow.set(this.isSlowType(connection.effectiveType));
      connection.addEventListener('change', () => {
        this._isSlow.set(this.isSlowType(connection.effectiveType));
      });
    }
  }

  private isSlowType(type: string): boolean {
    return ['slow-2g', '2g', '3g'].includes(type);
  }

  get isSlow() {
    return this._isSlow();
  }
}
